export default __webpack_public_path__ + "static/media/ReportExample2.92e61ff7.png";